/*eslint-disable*/
import React, { useState, useEffect, useContext,useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../../components/CircularLoading";
import { features, language } from "config";
import { FirebaseContext } from "common";
import AlertDialog from "../../components/AlertDialog";
import Material_React_Table from '../../components/Material_React_Table';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Box } from '@mui/material';
export default function AddUserAdmin(props) {
  const { api } = useContext(FirebaseContext);
  // console.log("Material react table :" ,Material_React_Table);
  const {
    updateProfile,
    editUser,
    deleteUser,
    checkUserExists,
    emailSignUp,
    clearLoginError,
  } = api;

  const usertypes = useSelector((state) => state.usertypes.userstypes);
  const [usertype, setUsertype] = useState([]);
  const auth = useSelector((state) => state.auth);
  const [data, setData] = useState([]);
  const usersdata = useSelector((state) => state.usersdata);
  const dispatch = useDispatch();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });


  
  useEffect(() => {
    if (usersdata.users) {
      setData(usersdata.users);
    }
  }, [usersdata.users]);

  useEffect(() => {
    if (usertypes) {
      const arr = Object.keys(usertypes).map((key) => ({
        label: key,
        value: usertypes[key],
      }));
      setUsertype(arr);
    }
  }, [usertypes]);


  const columns = useMemo(() => [
    {id: 'id', // Group for Employee-related columns
      header: 'Hidden id',
      columns: [
        {
          accessorKey: 'id',
          header: 'User id',
          enableEditing: false,
          Edit: () => null, //don't render anything in the editing modal for this column
          //or Edit: ({ cell, renderedCellValue }) => <>{renderedCellValue}</>, //render the normal cell value instead of a text field
          enableHiding: true,
        },
      ]
    },
    {
      id: 'employee', // Group for Employee-related columns
      header: 'Employee',
      columns: [
     
        {
          accessorKey: 'firstName', // First Name column
          header: language.first_name,
        },
        {
          accessorKey: 'lastName', // Last Name column
          header: language.last_name,
        },
        {
          accessorFn: (row) => `${row.firstName} ${row.lastName}`, // Combining first and last names
          id: 'name', // Required ID for accessorFn
          header: 'Full Name',
          size: 250,
         
        },
        {
          accessorKey: 'identityNumber', // Identity Number column
          header: 'Identity Number',
        },
        {
          accessorKey: 'email', // Email column with conditional editing
          header: language.email,
          enableEditing: features.AllowCriticalEditsAdmin,
          Cell: ({ cell }) =>
            features.AllowCriticalEditsAdmin ? (
              cell.getValue()
            ) : (
              <span style={{ color: 'gray' }}>Hidden for Demo</span>
            ),
        },
        {
          accessorKey: 'mobile', // Mobile column with conditional editing
          header: language.mobile,
          enableEditing: features.AllowCriticalEditsAdmin,
          Cell: ({ cell }) =>
            features.AllowCriticalEditsAdmin ? (
              cell.getValue()
            ) : (
              <span style={{ color: 'gray' }}>Hidden for Demo</span>
            ),
        },
      ],
    },
    {
      id: 'jobInfo', // Group for Job-related columns
      header: 'Job Info',
      columns: [
        {
          accessorKey: 'userType', // User Type column
          header: 'Usertype',
          enableEditing: true,
        },
        {
          accessorKey: 'adminHomeOffice',
          header: 'Office',
          enableEditing: true,
        },
        {
          accessorKey: 'password', // Password column with hidden content
          header: 'Password',
          // enableEditing: false,
          // Cell: () => <span style={{ color: 'gray' }}>Hidden for Security</span>,
        },
        // {
        //   accessorKey: 'salary', // Salary column with conditional styling
        //   filterFn: 'between',
        //   header: 'Salary',
        //   size: 200,
        //   Cell: ({ cell }) => (
        //     <Box
        //       component="span"
        //       sx={(theme) => ({
        //         backgroundColor:
        //           cell.getValue() < 50000
        //             ? theme.palette.error.dark
        //             : cell.getValue() >= 50000 && cell.getValue() < 75000
        //             ? theme.palette.warning.dark
        //             : theme.palette.success.dark,
        //         borderRadius: '0.25rem',
        //         color: '#fff',
        //         maxWidth: '9ch',
        //         p: '0.25rem',
        //       })}
        //     >
        //       {cell.getValue()?.toLocaleString('en-US', {
        //         style: 'currency',
        //         currency: 'USD',
        //         minimumFractionDigits: 0,
        //         maximumFractionDigits: 0,
        //       })}
        //     </Box>
        //   ),
        // },
        {
          accessorKey: 'walletBalance', // User Type column
          header: 'Wallet Balance',
          enableEditing: true,
        },
        {
          accessorKey: 'jobTitle', // Job Title column
          header: 'Job Title',
          size: 350,
        },
        {
          accessorFn: (row) => new Date(row.startDate), // Start Date column
          id: 'startDate',
          header: 'Start Date',
          filterVariant: 'date',
          filterFn: 'lessThan',
          sortingFn: 'datetime',
          Cell: ({ cell }) => cell.getValue()?.toLocaleDateString(),
          Header: ({ column }) => <em>{column.columnDef.header}</em>,
          muiFilterTextFieldProps: {
            sx: {
              minWidth: '250px',
            },
          },
        },
        {
          accessorKey: 'approved',
          header: language.account_approve,
          enableEditing: true,
          Cell: ({ cell }) => (
            <span
              style={{
                color: cell.getValue() ? 'green' : 'orange',
                fontWeight: 'bold',
              }}
            >
              {cell.getValue() ? 'Approved' : 'Pending'}
            </span>
          ),
        },
      ],
    },
  ], []);

  // console.log("colums :", columns);
  // console.log("data :", usersdata.users  );
  const handleRowAdd = (newData) => {
    console.log("New data: ",newData);
    
    new Promise((resolve, reject) => {
      setTimeout(() => {
        if (!newData.firstName || !newData.lastName) {
          alert("First name and last name are required.");
          reject();
      }
        checkUserExists(newData).then((res) => {
          if (res.users && res.users.length > 0) {
            alert(language.user_exists);
            reject();
          } else if (res.error) {
            alert(language.email_or_mobile_issue);
            reject();
          } else {

            newData["createdByAdmin"] = true;

            // newData["userType"] = usertype;
            newData["createdAt"] = new Date().toISOString();
            newData["referralId"] =
              newData.firstName.toLowerCase() +
              Math.floor(1000 + Math.random() * 9000).toString();
            
            newData["username"] =
              newData.firstName.toLowerCase() +
              newData.lastName.toLowerCase() +
              Math.floor(1000 + Math.random() * 9000).toString();

            let role = auth.info.profile.userType;
            if (role === usertype) {
              newData[usertype] = auth.info.uid;
            }

            console.log("✅ Final `updatedData` after modifications:", newData);  
         
            emailSignUp(newData).then((res) => {
              resolve();
              console.log("i am the back data", res);
              if (res.uid) {
                setTimeout(() => {
                  setCommonAlert({
                    open: true,
                    msg: language.account_create_successfully
                  });
                  // props.history.push("/login");
                  console.log(newData);
                }, 3000);
              } else {
                setCommonAlert({
                  open: true,
                  msg: language.reg_error
                });
              }
            });
          }
        });
      }, 600);

    });
  };
  

  const handleRowUpdate = (newData) => {
    console.log("New data: ",newData);
    return new Promise((resolve) => {
      dispatch(editUser(newData.id, newData));
      resolve();
    });
  };

  const handleRowDelete = (oldData) => {
    return new Promise((resolve) => {
      if (features.AllowCriticalEditsAdmin) {
        dispatch(deleteUser(oldData.id));
      } else {
        alert(language.demo_mode);
      }
      resolve();
    });
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };

  return usersdata.loading ? (
    <CircularLoading />
  ) : (
    <>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
      <>
        <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
          {commonAlert.msg}
        </AlertDialog>
   
        <Material_React_Table
          data={usersdata.users }
          columns={columns }
          userInitialState={{
            columnVisibility: { id: false }, // This hides the "id" column initially
          }}
          onRowAdd={handleRowAdd}
          onRowUpdate={handleRowUpdate}
          onRowDelete={handleRowDelete}
        />
      </>
    </LocalizationProvider>
    </>
  );
}
